export default (length: number) =>
  Array.from({length}).map((_, index) => index);
